/** @prettier */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const EventName = ({ children, fallback, home, vs, away }) => {
  const segments = children.split(/ (at|vs) /);

  if (segments.length !== 3) {
    return fallback(children);
  }

  return (
    <Fragment>
      {home(segments[0])} {vs(segments[1])} {away(segments[2])}
    </Fragment>
  );
};

EventName.defaultProps = {
  children: '',
  fallback: (str) => str,
  home: (str) => str,
  vs: (str) => str,
  away: (str) => str,
};

EventName.propTypes = {
  children: PropTypes.string.isRequired,
  fallback: PropTypes.func.isRequired,
  home: PropTypes.func.isRequired,
  vs: PropTypes.func.isRequired,
  away: PropTypes.func.isRequired,
};

export default EventName;
